import { Panel, StatelessAccordion } from 'baseui/accordion'
import PropTypes from 'prop-types'
import { ParagraphMedium } from 'baseui/typography'
import { useTranslation } from 'react-i18next'
import { Fragment, useState } from 'react'

const MeterCompleteInformation = ({ currentValue, type }) => {
  const { t } = useTranslation()
  const [expanded, setExpanded] = useState(['basic0'])
  const panels = []
  const panelsBasic = []
  const gasMeterDetails = currentValue?.gas ?? null
  // Consumption
  if (
    gasMeterDetails &&
    typeof gasMeterDetails.yearlyExtrapolation !== 'undefined' &&
    gasMeterDetails.yearlyExtrapolation !== null &&
    type === 'client'
  ) {
    const text = []

    text.push(`${gasMeterDetails.yearlyExtrapolation} kWh`)

    panels.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.consumption_title'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  // Basic information
  if (
    gasMeterDetails &&
    (gasMeterDetails?.deliveryPoint?.state ||
      gasMeterDetails?.deliveryPoint?.deliveryStatus ||
      gasMeterDetails?.deliveryPoint?.meterType ||
      gasMeterDetails?.deliveryPoint?.readingFrequency ||
      gasMeterDetails?.deliveryPoint?.gridRate)
  ) {
    const state = gasMeterDetails?.deliveryPoint?.state
    const deliveryStatus = gasMeterDetails?.deliveryPoint?.deliveryStatus
    const meterType = gasMeterDetails?.deliveryPoint?.meterType
    const readingFrequency = gasMeterDetails?.deliveryPoint?.readingFrequency
    const gridRate = gasMeterDetails?.deliveryPoint?.gridRate
    const text = []

    if (state) {
      text.push(
        `${t('subscriptionForm:pce_module.meter_complete_information.basic_information.state')} : ${t('subscriptionForm:pce_module.meter_complete_information.basic_information.' + state)}`,
      )
    }

    if (deliveryStatus) {
      text.push(
        `${t('subscriptionForm:pce_module.meter_complete_information.basic_information.delivery_status')} : ${deliveryStatus}`,
      )
    }

    if (meterType) {
      text.push(
        `${t('subscriptionForm:pce_module.meter_complete_information.basic_information.meter_type')} : ${meterType}`,
      )
    }

    if (readingFrequency) {
      text.push(
        `${t('subscriptionForm:pce_module.meter_complete_information.basic_information.reading_frequency')} : ${readingFrequency}`,
      )
    }

    if (gridRate) {
      text.push(
        `${t('subscriptionForm:pce_module.meter_complete_information.basic_information.grid_rate')} : ${gridRate}`,
      )
    }

    panelsBasic.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.basic_information.title'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  // AddressSearch information
  if (gasMeterDetails && gasMeterDetails?.deliveryPoint?.address && type === 'client') {
    const address = gasMeterDetails?.deliveryPoint?.address
    const text = []

    if (address.street) {
      const streetNumber = address.number ? address.number + ' ' : ''
      text.push(streetNumber + address.street)
    }

    if (address.townName) {
      text.push(`${address.postalCode ?? ''} ${address.townName}`)
    }

    panelsBasic.push({
      title: t('subscriptionForm:pce_module.meter_complete_information.address.address'),
      text: text.length > 0 ? text : [t('subscriptionForm:pce_module.meter_complete_information.no_info_available')],
    })
  }

  return (
    <StatelessAccordion
      expanded={expanded}
      onChange={({ expanded }) => {
        setExpanded(expanded)
      }}
    >
      {panelsBasic.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'basic' + indexPanel}>
            <Fragment>
              {content.text.map((content, index) => {
                return <ParagraphMedium key={'p_basic' + index}>{content}</ParagraphMedium>
              })}
            </Fragment>
          </Panel>
        )
      })}
      {panels.map((content, indexPanel) => {
        return (
          <Panel title={content.title} key={'details' + indexPanel}>
            <Fragment>
              {content.text.map((content, index) => {
                return <ParagraphMedium key={'p_panels' + index}>{content}</ParagraphMedium>
              })}
            </Fragment>
          </Panel>
        )
      })}
    </StatelessAccordion>
  )
}

MeterCompleteInformation.propTypes = {
  currentValue: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  type: PropTypes.string,
}

export default MeterCompleteInformation
